// extracted by mini-css-extract-plugin
export default {"tab":"Tab_tab__+Vkqv","isActive":"Tab_isActive__SpNd-"};